define('page/aboutnews', [
    'jquery'
], function ($) {
    $(".article").on("click", function () {
        $(".article").removeClass("active");
        $("#recommentarticle").css("display", "none");
        $("#newarticle").css("display", "none");
        $("#" + $(this).attr("data-id")).css("display", "block");
        $(this).addClass("active");
    })
})  ;
